import handlerTable from "../../handlers";
// import { MockHandlerReturn } from "../../mocks/websocket-server/variable";
import { defaultOptions } from "./index";
import MockedRequestWrapper from "./requestWrapper-mock";
import * as methods from "../../constants/methods";
import { findKey } from "lodash";
import { Request } from "../../proto/Request_pb";

const singletonEnforcer = Symbol();
export const mockRequestMap: { [key: string]: MockedRequestWrapper } = {};

export interface MockedRequest<I> {
  request: { id: string };
  actionId: number;
  params: I;
}

export default class MockSocketClient {
  static instance: MockSocketClient;
  public _socket?: WebSocket;
  static symmetricKey: Uint8Array;
  private constructor(enforcer: Symbol) {
    if (!!enforcer || enforcer === singletonEnforcer) {
      this.connect();
    }
  }

  static getInstance(): MockSocketClient {
    if (!MockSocketClient.instance) {
      MockSocketClient.instance = new MockSocketClient(singletonEnforcer);
    }
    return MockSocketClient.instance;
  }

  __done(requestId: string) {}

  public sendMessage(packet: MockedRequest<any>) {
    console.debug(`#🧪👆 ${findKey(methods, (id) => id === packet.actionId)}`, packet.params, "actionId :", packet.actionId);
    let promise: Promise<any>;
    promise = new Promise((resolve, reject) => {
      const wrapper = new MockedRequestWrapper(resolve, reject, this.__done, packet.actionId, packet, {
        ...defaultOptions,
      });
      wrapper.promise = promise;
      mockRequestMap[packet.request.id] = wrapper;
      console.log("MOCK CLIENT SOCKET", packet);
      this._socket?.send(JSON.stringify(packet));
    });
    return promise;
  }

  connect() {
    this._socket = new WebSocket("ws://localhost:4750");

    this._socket.onopen = () => {
      // resolve(true);
    };

    this._socket.onmessage = (message: MessageEvent) => {
      const response = JSON.parse(message.data) as { request: Request.AsObject } & any;
      const responseId = response.response.id;
      const wrapper = mockRequestMap[responseId];

      if (!wrapper) return;

      wrapper.resolve(response);
      console.debug(`#🧪👇 ${findKey(methods, (id) => id === wrapper.actionId)} `, response);

      const handlerClass = handlerTable[wrapper.actionId + 30000];

      if (handlerClass) {
        const handler = new handlerClass({ ...response, toObject: () => response }, { ...wrapper.proto, toObject: () => wrapper.proto });
        handler.handle();
      }
    };

    this._socket.onerror = (error) => {
      console.log("[MOCK_CLIENT] ERRORED", error);
      // reject(error);
    };

    this._socket.onclose = (event) => {
      console.log("[MOCK_CLIENT] CLOSED");
    };
  }
}
